import { render, staticRenderFns } from "./PagePreview.vue?vue&type=template&id=6fb79f42&scoped=true&"
import script from "./PagePreview.vue?vue&type=script&lang=js&"
export * from "./PagePreview.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PagePreview.vue?vue&type=style&index=0&id=6fb79f42&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6fb79f42",
  "3052ec64"
  
)

export default component.exports